import React, { useCallback, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Header from "../header/Header";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Swal from "sweetalert2";
import TableContainer from "@mui/material/TableContainer";
import { API_LOCAL, API_URL } from "../../Constants";
import SideDrawer from "../header/SideDrawer";
import { TablePagination } from "@material-ui/core";
import FormDialog from "./FormDialog";
import { Link, useNavigate } from "react-router-dom";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  Skeleton,
  Typography,
  Divider,
  Chip,
  CircularProgress,
} from "@mui/material";
import Modal from "../modal/Modal";
import { axiosClient, axiosClientCloud } from "../AxiosClient";
import PaymentIcon from "@mui/icons-material/Payment";
import DeleteIcon from "@mui/icons-material/Delete";
import ScheduleIcon from "@mui/icons-material/Schedule";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import TuneIcon from "@mui/icons-material/Tune";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import ViewListIcon from "@mui/icons-material/ViewList";
import DesplegarCuotasModal from "./DesplegarCuotasModal";
import ReasignarPagoModal from "./ReasignarPagoModal";
import {
  deployCreditQuotas,
  getDeployCreditQuotasErrorMessage,
} from "./deployCreditQuotas";

let apiUrl = API_URL;

const ButtonPrincipal = styled(Button)({
  flexGrow: 0,
  borderRadius: "20px",
  gap: "10px",
  color: "#FFFFFF",
  backgroundColor: "#161e55",
  "&:hover": {
    backgroundColor: "#A8C8AF",
  },
});

const DashboardActionButton = styled(Button)({
  minHeight: "44px",
  borderRadius: "12px",
  padding: "10px 16px",
  color: "#FFFFFF",
  backgroundColor: "#161e55",
  fontWeight: 600,
  textTransform: "none",
  whiteSpace: "nowrap",
  boxShadow: "0 3px 10px rgba(22, 30, 85, 0.16)",
  transition: "transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",
  "&:hover": {
    backgroundColor: "#26316f",
    boxShadow: "0 6px 16px rgba(22, 30, 85, 0.22)",
    transform: "translateY(-1px)",
  },
  "&:focus-visible": {
    outline: "3px solid rgba(168, 200, 175, 0.7)",
    outlineOffset: "2px",
  },
});

const useStyles = makeStyles((theme) => ({
  mora: {
    color: "#D10909",
  },
  celda: {
    padding: "300px",
  },
  dialogo: {
    width: "800px",
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

var formatter = new Intl.NumberFormat("es-US", {
  style: "currency",
  currency: "COP",
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const ButtonFile = styled(Button)({
  flexGrow: 0,
  borderRadius: "12px",
  gap: "8px",
  backgroundColor: "#f8f9fa",
  color: "#161e55",
  padding: "12px 24px",
  border: "2px dashed #161e55",
  fontWeight: 600,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#e9ecef",
    borderColor: "#A8C8AF",
  },
});

const ModernButton = styled(Button)({
  flexGrow: 0,
  borderRadius: "12px",
  gap: "8px",
  padding: "12px 20px",
  color: "#FFFFFF",
  backgroundColor: "#161e55",
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "0 4px 12px rgba(22, 30, 85, 0.15)",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: "#A8C8AF",
    transform: "translateY(-2px)",
    boxShadow: "0 6px 20px rgba(168, 200, 175, 0.3)",
  },
  "&:disabled": {
    color: "#FFFFFF",
    backgroundColor: "#161e55",
  },
});

const UploadArea = styled(Box)({
  border: "2px dashed #d1d5db",
  borderRadius: "16px",
  padding: "24px",
  backgroundColor: "#f9fafb",
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    borderColor: "#161e55",
    backgroundColor: "#f3f4f6",
  },
});

const dateFormater = (dateToFormat) => {
  if (dateToFormat != "" && dateToFormat != undefined) {
    let justDate = dateToFormat.toString().split("T")[0].split("-");
    return justDate[2] + "-" + justDate[1] + "-" + justDate[0];
  } else {
    return "Fecha Invalida";
  }
};

const dateToPayFormat = (dateToFormat) => {
  if (dateToFormat != "" && dateToFormat != undefined) {
    let justDate = dateToFormat.toString().split("-");
    let day = justDate[0];
    let month = justDate[1];
    if (day.length == 1) {
      day = "0" + justDate[0];
    }
    if (month.length == 1) {
      month = "0" + justDate[1];
    }
    console.log(justDate[2] + "-" + month + "-" + day + "T00:00");
    return justDate[2] + "-" + month + "-" + day + "T00:00";
  } else {
    return "Fecha Invalida";
  }
};

const handleCobranzaDetail = (clientUuid) => {
  localStorage.setItem("clientUuid", clientUuid);
};

const userUuids = localStorage.getItem("userUuid");

export default function Cobranza() {
  const classes = useStyles();

  const handlePayQuota = (quotaUuid) => {
    let valueToPay = document.getElementById("valueToPay-" + quotaUuid).value;
    let dateToPay = dateToPayFormat(
      document.getElementById("dateToPay-" + quotaUuid).value
    );

    if (valueToPay == undefined || valueToPay == "") {
      alert("monto a pagar inválido... revisar");
    } else {
      Swal.fire({
        title: "¿Desea recaudar con intereses de mora?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: "#161e55",
        cancelButtonColor: "#387A9C",
        confirmButtonText: "con Mora",
        denyButtonText: "sin Mora",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        let quotaRequest = {
          paidValue: valueToPay,
          collector: "PRAMI",
          paidDate: dateToPay,
        };
        if (result.isConfirmed) {
          axiosClient
            .patch(`/v1/quotas/${quotaUuid}/pay-with-mora`, quotaRequest, {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            })
            .then((response) => {
              console.log(response.data.uuid);
              setQuotas(response.data.uuid);
            })
            .catch((error) => {
              console.log(
                "Hubo un problema con la petición Axios: " + error.message
              );
            });
        } else if (result.isDenied) {
          axiosClient
            .patch(`/v1/quotas/${quotaUuid}/pay`, quotaRequest, {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            })
            .then((response) => {
              console.log(response.data.uuid);
              setQuotas(response.data.uuid);
            })
            .catch((error) => {
              console.log(
                "Hubo un problema con la petición Axios: " + error.message
              );
            });
        }
      });
    }
  };

  const [data, setData] = useState();
  const [page, setPage] = useState(0);
  const [infos, setInfos] = useState({ size: 20, totalElements: 0 });
  const [currentDate, setCurrentDate] = useState("");
  const [checkboxes, setCheckboxes] = useState([
    { id: 1, isChecked: false, conMora: "mora 1", sinMora: "sin mora" },
  ]);
  const [dataClient, setDataClient] = useState([]);
  const [client, setClient] = useState("");
  const [textClient, setTextClient] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [pageClient, setPageclient] = useState(0);
  const [updateComment, setUpdateComment] = useState("");
  const [quotas, setQuotas] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const importerDocument = useRef(null);
  const [isImporter, setIsImporter] = useState(false);
  const [loadingStates, setLoadingStates] = useState({
    generarAplicador: false,
    ajusteAplicacion: false,
    eliminarRecaudo: false,
  });
  const [deployQuotasOpen, setDeployQuotasOpen] = useState(false);
  const [deployQuotasLoading, setDeployQuotasLoading] = useState(false);
  const [deployQuotasError, setDeployQuotasError] = useState("");
  const [reassignPaymentOpen, setReassignPaymentOpen] = useState(false);
  const navigate = useNavigate();

  const loadQuotas = useCallback(async (requestedPage = 0, clientUuid = "") => {
    const hasClientFilter = Boolean(clientUuid);
    const url = hasClientFilter
      ? `/v1/quotas/list/client/${clientUuid}`
      : "/v1/quotas";
    const params = {
      sort: "payDate,asc",
      size: 20,
      page: requestedPage,
      ...(!hasClientFilter && { search: "status:PENDING" }),
    };

    try {
      const response = await axiosClient.get(url, { params });
      setData(response.data.content);
      setInfos(response.data);
      setCheckboxes(
        response.data.content.map((row) => ({
          id: row.uuid,
          isChecked: false,
          conMora: 20,
          sinMora: 50,
        }))
      );
    } catch (error) {
      console.log("Error al consultar cuotas: " + error.message);
    }
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setPageclient(newPage);
    loadQuotas(newPage, client);
  };

  const handleOpenDeployQuotas = () => {
    setDeployQuotasError("");
    setDeployQuotasOpen(true);
  };

  const handleOpenReassignPayment = () => {
    setReassignPaymentOpen(true);
  };

  const handleCloseReassignPayment = () => {
    setReassignPaymentOpen(false);
  };

  const handleCloseDeployQuotas = () => {
    if (!deployQuotasLoading) {
      setDeployQuotasOpen(false);
      setDeployQuotasError("");
    }
  };

  const handleDeployQuotas = async (oldId) => {
    if (deployQuotasLoading) {
      return;
    }

    setDeployQuotasLoading(true);
    setDeployQuotasError("");

    try {
      const approvedCredit = await deployCreditQuotas(axiosClient, oldId);
      const approvedCreditOldId = approvedCredit?.oldId ?? oldId;

      setDeployQuotasOpen(false);
      setPage(0);
      setPageclient(0);
      await loadQuotas(0, client);
      await Swal.fire({
        icon: "success",
        title: "Cuotas desplegadas",
        text: `Se desplegaron correctamente las cuotas del crédito ${approvedCreditOldId}.`,
        confirmButtonColor: "#161e55",
      });
    } catch (error) {
      setDeployQuotasError(getDeployCreditQuotasErrorMessage(error));
    } finally {
      setDeployQuotasLoading(false);
    }
  };

  // Función utilitaria para descargar archivos
  const downloadFile = (response, defaultFilename = "archivo.xlsx") => {
    try {
      // Crear el blob
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Crear URL temporal
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Obtener nombre del archivo desde headers o usar por defecto
      let filename = defaultFilename;
      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      } else {
        const timestamp = new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/[:-]/g, "");
        const name = defaultFilename.replace(".xlsx", "");
        filename = `${name}_${timestamp}.xlsx`;
      }

      // Descargar archivo
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      // Limpiar recursos
      link.remove();
      window.URL.revokeObjectURL(url);

      return filename; // Retornar el nombre del archivo descargado
    } catch (error) {
      console.error("Error al descargar archivo:", error);
      throw new Error("Error al procesar la descarga del archivo");
    }
  };

  const handleChangeValue = (quotaUuid) => {
    console.log("gol");
  };

  const handleChangeListSearch = (event, value) => {
    if (!value || typeof value === "string") {
      setSelectedClient(null);
      return;
    }
    setSelectedClient(value);
  };

  const handleChangeWriteSearch = (event, value) => {
    const inputText = value || "";
    setTextClient(inputText);
    if (inputText === "") {
      setClient("");
      setSelectedClient(null);
      return;
    }
    const normalizedInput = inputText.trim().toLowerCase();
    const matchedClient = dataClient.find((item) => {
      const fullName = item?.fullName?.toLowerCase() || "";
      const name = item?.name?.toLowerCase() || "";
      const lastName = item?.lastName?.toLowerCase() || "";
      const documentNumber = String(item?.documentNumber || "").toLowerCase();
      return (
        fullName === normalizedInput ||
        name === normalizedInput ||
        lastName === normalizedInput ||
        documentNumber === normalizedInput
      );
    });
    setSelectedClient(matchedClient || null);
  };

  const handleSearchClient = () => {
    const normalizedSearch = textClient.trim().toLowerCase();
    if (normalizedSearch === "") {
      setClient("");
      return;
    }

    const clientToSearch =
      selectedClient?.uuid
        ? selectedClient
        : dataClient.find(
            (item) => {
              const fullName = item?.fullName?.toLowerCase() || "";
              const name = item?.name?.toLowerCase() || "";
              const lastName = item?.lastName?.toLowerCase() || "";
              const documentNumber = String(item?.documentNumber || "").toLowerCase();
              return (
                item?.uuid &&
                (fullName === normalizedSearch ||
                  name === normalizedSearch ||
                  lastName === normalizedSearch ||
                  documentNumber === normalizedSearch)
              );
            }
          );

    if (!clientToSearch?.uuid) {
      Swal.fire({
        icon: "warning",
        title: "Cliente no válido",
        text: "Selecciona un cliente de la lista antes de buscar.",
        confirmButtonColor: "#161e55",
      });
      return;
    }

    setClient(clientToSearch.uuid);
  };

  const getOptionLabel = (option) => {
    if (typeof option === "string") {
      return option;
    }
    return (
      option?.fullName ||
      `${option?.name || ""} ${option?.lastName || ""}`.trim() ||
      String(option?.documentNumber || "")
    );
  };

  const handleModal = () => {
    setIsOpen(!isOpen);
    setIsImporter(false);
  };

  const handleChangeImporter = () => {
    if (importerDocument?.current?.files?.length > 0) {
      setIsImporter(true);
      console.log(importerDocument?.current?.files[0]?.name);
    } else {
      setIsImporter(false);
    }
  };

  const handleImport = () => {
    const csv = new FormData();
    csv.append("file", importerDocument?.current?.files[0]);

    axiosClient
      .post(`/v1/quotas/import/${userUuids}`, csv)
      .then((response) => {
        console.log(response);
        handleModal();
      })
      .catch((error) => {
        console.log("Bad request: " + error.message);
      });
  };

  const handleDeleteQuotas = () => {
    const csv = new FormData();
    csv.append("file", importerDocument?.current?.files[0]);

    axiosClient
      .post(`/v1/quotas/delete/import/${userUuids}`, csv)
      .then((response) => {
        console.log(response);
        handleModal();
      })
      .catch((error) => {
        console.log("Bad request: " + error.message);
      });
  };

  const handleFechaCompromiso = () => {
    const csv = new FormData();
    csv.append("file", importerDocument?.current?.files[0]);

    axiosClient
      .post(`/v1/quotas/import/update-quotas`, csv)
      .then((response) => {
        console.log(response);
        handleModal();
      })
      .catch((error) => {
        console.log("Bad request: " + error.message);
      });
  };

  const handleEliminarCredito = () => {
    navigate("/homeAdmin/eliminar-creditos");
  };

  const handleGestionCobranza = async () => {
    const csv = new FormData();
    csv.append("file", importerDocument?.current?.files[0]);

    try {
      const response = await axiosClient.post(
        `/v1/collectionManagement/import`,
        csv
      );

      Swal.fire({
        icon: "success",
        title: "Importación exitosa",
        text: "El archivo se ha procesado correctamente.",
        confirmButtonColor: "#161e55",
      });

      handleModal();

      if (importerDocument?.current) {
        importerDocument.current.value = "";
      }
    } catch (error) {
      console.log("Error response:", error.response);

      let errorMessage = "Ocurrió un error al procesar la solicitud";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        confirmButtonColor: "#161e55",
      });
    }
  };

  const handleGenerarAplicadorPagos = async () => {
    const csv = new FormData();
    csv.append("file", importerDocument?.current?.files[0]);

    setLoadingStates((prev) => ({ ...prev, generarAplicador: true }));

    try {
      const response = await axiosClient.post(
        `v1/payment-record/import/${userUuids}`,
        csv,
        {
          responseType: "blob", // Importante para archivos
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Usar la función utilitaria para descargar
      const filename = downloadFile(response, "aplicador_pagos.xlsx");

      Swal.fire({
        icon: "success",
        title: "Aplicador de pagos generado",
        text: `El archivo "${filename}" se ha descargado correctamente.`,
        confirmButtonColor: "#161e55",
      });

      handleModal();

      if (importerDocument?.current) {
        importerDocument.current.value = "";
      }
    } catch (error) {
      console.log("Error response:", error.response);

      let errorMessage = "Ocurrió un error al generar el aplicador de pagos";

      // Verificar si es un error de descarga o de API
      if (error.message === "Error al procesar la descarga del archivo") {
        errorMessage = "Error al descargar el archivo generado";
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        confirmButtonColor: "#161e55",
      });
    } finally {
      setLoadingStates((prev) => ({ ...prev, generarAplicador: false }));
    }
  };

  const handleAjusteAplicacionPagos = async () => {
    const csv = new FormData();
    csv.append("file", importerDocument?.current?.files[0]);

    setLoadingStates((prev) => ({ ...prev, ajusteAplicacion: true }));

    try {
      const response = await axiosClient.post(
        `/v1/payment-record/import-adjustments`,
        csv
      );

      Swal.fire({
        icon: "success",
        title: "Ajuste aplicado",
        text: "El ajuste de aplicación de pagos se ha procesado correctamente.",
        confirmButtonColor: "#161e55",
      });

      handleModal();

      if (importerDocument?.current) {
        importerDocument.current.value = "";
      }
    } catch (error) {
      console.log("Error response:", error.response);

      let errorMessage = "Ocurrió un error al aplicar el ajuste";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        confirmButtonColor: "#161e55",
      });
    } finally {
      setLoadingStates((prev) => ({ ...prev, ajusteAplicacion: false }));
    }
  };

  const handleEliminarRecaudo = async () => {
    const csv = new FormData();
    csv.append("file", importerDocument?.current?.files[0]);

    setLoadingStates((prev) => ({ ...prev, eliminarRecaudo: true }));

    try {
      const response = await axiosClient.post(
        `v1/payment-record/eliminate-payment-record/${userUuids}`,
        csv
      );

      Swal.fire({
        icon: "success",
        title: "Recaudo eliminado",
        text: "El recaudo se ha eliminado correctamente.",
        confirmButtonColor: "#161e55",
      });

      handleModal();

      if (importerDocument?.current) {
        importerDocument.current.value = "";
      }
    } catch (error) {
      console.log("Error response:", error.response);

      let errorMessage = "Ocurrió un error al eliminar el recaudo";

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        confirmButtonColor: "#161e55",
      });
    } finally {
      setLoadingStates((prev) => ({ ...prev, eliminarRecaudo: false }));
    }
  };

  useEffect(() => {
    if (localStorage.getItem("userUuid") == null) {
      window.location = "/admin";
    }

    let today = new Date();
    let day = today.getDate();
    let month = today.getMonth() + 1;
    let year = today.getFullYear();
    setCurrentDate(day + "-" + month + "-" + year);
  }, []);

  // Consultar datos para mostrar en la lista del buscador
  useEffect(() => {
    axiosClient
      .get(`/v1/clients`, {
        params: {
          search: `documentNumber:'*${textClient}*' OR name:'*${textClient}*' OR lastName:'*${textClient}*' OR fullName:'*${textClient}*'`,
        },
      })
      .then((response) => {
        if (response.data.content.length !== 0) {
          setDataClient(response.data.content);
        }
      })
      .catch((error) => {
        console.log("Error: " + error.message);
      });
  }, [textClient]);

  //Consultar cuotas del cliente
  useEffect(() => {
    setPage(0);
    setPageclient(0);
    loadQuotas(0, client);
  }, [client, loadQuotas, quotas, updateComment]);

  return (
    <React.Fragment>
      {/* <Box sx={{ display: 'flex' }}> */}
      <CssBaseline />
      {/* <Header position="fixed" /> */}
      {/* <SideDrawer currentPage={'Cobranza'}></SideDrawer> */}
      <br />
      <br />
      <Toolbar />
      <Box sx={{ width: "100%" }}>
        <Stack spacing={2}>
          <Item>.</Item>
          <Item></Item>
          {/* first line */}
          <Grid container spacing={2} sx={{ width: "100%", margin: 0 }}>
            <Paper
              elevation={0}
              sx={{
                width: "100%",
                margin: "10px 0 18px",
                padding: { xs: "20px 16px", md: "24px" },
                border: "1px solid #e5e7eb",
                borderRadius: "16px",
                backgroundColor: "#ffffff",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: { xs: "flex-start", lg: "center" },
                  justifyContent: "space-between",
                  flexDirection: { xs: "column", lg: "row" },
                  gap: 2.5,
                }}
              >
                <Box>
                  <Typography
                    component="h1"
                    variant="h4"
                    sx={{
                      color: "#161e55",
                      fontWeight: 700,
                      lineHeight: 1.2,
                      mb: 0.5,
                    }}
                  >
                    Tablero de Cobranza
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#6b7280" }}>
                    Consulta clientes y gestiona las operaciones de recaudo.
                  </Typography>
                </Box>

                <Box
                  aria-label="Acciones de cobranza"
                  sx={{
                    display: "flex",
                    gap: 1.25,
                    flexWrap: "wrap",
                    width: { xs: "100%", lg: "auto" },
                  }}
                >
                  <DashboardActionButton
                    onClick={handleModal}
                    startIcon={<UploadFileIcon />}
                  >
                    Importar
                  </DashboardActionButton>
                  <DashboardActionButton
                    onClick={handleOpenReassignPayment}
                    startIcon={<SwapHorizIcon />}
                  >
                    Reasignar pago
                  </DashboardActionButton>
                  <DashboardActionButton
                    onClick={handleOpenDeployQuotas}
                    startIcon={<ViewListIcon />}
                  >
                    Desplegar cuotas
                  </DashboardActionButton>
                  <DashboardActionButton
                    onClick={handleEliminarCredito}
                    startIcon={<DeleteIcon />}
                  >
                    Eliminar crédito
                  </DashboardActionButton>
                </Box>
              </Box>

              <Divider sx={{ my: 2.5 }} />

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  width: { xs: "100%", md: "min(100%, 560px)" },
                  ml: { md: "auto" },
                }}
              >
                  <Autocomplete
                    id="search"
                    freeSolo
                    sx={{ flexGrow: 1 }}
                    onInputChange={handleChangeWriteSearch}
                    onChange={handleChangeListSearch}
                    options={dataClient}
                    getOptionLabel={getOptionLabel}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Buscar cliente"
                        placeholder="Nombre o número de documento"
                      />
                    )}
                  />
                  <ButtonPrincipal
                    onClick={handleSearchClient}
                    startIcon={<SearchIcon />}
                    sx={{ minHeight: "44px", px: 2 }}
                  >
                    Buscar
                  </ButtonPrincipal>
              </Box>
            </Paper>
          </Grid>
          {/* second line */}
          <Grid container spacing={2} sx={{ width: "100%" }}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Comercio</TableCell>
                    <TableCell align="center">Cliente</TableCell>
                    <TableCell align="center">Valor Cuota</TableCell>
                    <TableCell align="center"># cuota</TableCell>
                    <TableCell align="center">Dia a Pagar (Mora)</TableCell>
                    <TableCell align="center">
                      Fecha de pago (DD/MM/YYYY)
                    </TableCell>
                    <TableCell align="center">Comentarios</TableCell>
                    <TableCell align="center">Recaudo</TableCell>
                    <TableCell align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data ? (
                    data.map((row) => (
                      <TableRow
                        key={row.uuid}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell className={classes.celda} align="center">
                          {row?.credit?.commerce?.companyName}
                        </TableCell>
                        <TableCell align="center">
                          <Link
                            to="/homeAdmin/cobranza-detail"
                            onClick={() =>
                              handleCobranzaDetail(row.credit.client.uuid)
                            }
                          >
                            {row?.credit?.client?.name}{" "}
                            {row?.credit?.client?.lastName}
                          </Link>
                          <br />
                          {/* <a href="cobranza-detail" onClick={() => handleCobranzaDetail(row.credit.client.uuid)}>
                                                        {row.credit.client.name} {row.credit.client.lastName}
                                                    </a> <br /> */}
                          {row?.credit?.client?.documentType}{" "}
                          {row?.credit?.client?.documentNumber} <br />
                          {row?.credit?.client?.cellphone}
                        </TableCell>
                        <TableCell align="center">
                          {formatter.format(row.value)} <br />{" "}
                          <h5 className={classes.mora}>
                            {formatter.format(
                              row.interesesMoratoriosGenerados + row.value
                            )}
                          </h5>
                        </TableCell>
                        <TableCell align="center">{row.quotaNumber}</TableCell>
                        <TableCell align="center">
                          {dateFormater(row.payDate)}{" "}
                          <h5 className={classes.mora}>{row.moraDays}</h5>
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            id={"dateToPay-" + row.uuid}
                            label=""
                            defaultValue={currentDate}
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <FormDialog
                            quotaUuid={row.uuid}
                            quotaComment={row.comments}
                            className={classes.dialogo}
                            setComment={setUpdateComment}
                          ></FormDialog>
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            id={"valueToPay-" + row.uuid}
                            label=""
                            variant="standard"
                            type="number"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <ButtonPrincipal
                            onClick={() => handlePayQuota(row.uuid)}
                          >
                            Pagar
                          </ButtonPrincipal>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell>
                        <Skeleton variant="rounded" animation="wave"></Skeleton>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <Skeleton
                            variant="rounded"
                            animation="wave"
                          ></Skeleton>
                          <Skeleton
                            variant="rounded"
                            animation="wave"
                          ></Skeleton>
                          <Skeleton
                            variant="rounded"
                            animation="wave"
                          ></Skeleton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <Skeleton
                            variant="rounded"
                            animation="wave"
                          ></Skeleton>
                          <Skeleton
                            variant="rounded"
                            animation="wave"
                          ></Skeleton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <Skeleton
                            variant="rounded"
                            animation="wave"
                          ></Skeleton>
                          <Skeleton
                            variant="rounded"
                            animation="wave"
                          ></Skeleton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rounded" animation="wave"></Skeleton>
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rounded" animation="wave"></Skeleton>
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="rounded" animation="wave"></Skeleton>
                      </TableCell>
                      <TableCell>
                        <Skeleton variant="circular" animation="wave">
                          {" "}
                          <ButtonPrincipal>Pagar</ButtonPrincipal>{" "}
                        </Skeleton>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                rowsPerPageOptions={[infos.size]}
                count={infos.totalElements}
                rowsPerPage={infos.size}
                page={page}
                onPageChange={handleChangePage}
              />
            </TableContainer>
          </Grid>
        </Stack>
      </Box>
      <DesplegarCuotasModal
        errorMessage={deployQuotasError}
        loading={deployQuotasLoading}
        onClose={handleCloseDeployQuotas}
        onSubmit={handleDeployQuotas}
        open={deployQuotasOpen}
      />
      <ReasignarPagoModal
        onClose={handleCloseReassignPayment}
        open={reassignPaymentOpen}
      />
      {isOpen && (
        <Modal activeModal={isOpen} handleModal={handleModal}>
          <Box
            sx={{
              padding: "32px",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            {/* Header */}
            <Box sx={{ textAlign: "center", marginBottom: "32px" }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: "#161e55",
                  marginBottom: "8px",
                }}
              >
                Gestión de Cuotas
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#6b7280",
                  fontSize: "16px",
                }}
              >
                Selecciona un archivo CSV y elige la acción que deseas realizar
              </Typography>
            </Box>

            {/* Upload Section */}
            <UploadArea sx={{ marginBottom: "32px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <UploadFileIcon
                  sx={{
                    fontSize: 48,
                    color: isImporter ? "#10b981" : "#9ca3af",
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: "#374151",
                    textAlign: "center",
                  }}
                >
                  {isImporter
                    ? "Archivo cargado exitosamente"
                    : "Subir archivo CSV"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#6b7280",
                    textAlign: "center",
                    marginBottom: "16px",
                  }}
                >
                  Selecciona un archivo CSV con las cuotas a procesar
                </Typography>
                <ButtonFile
                  onClick={(e) => importerDocument.current?.click()}
                  startIcon={<UploadFileIcon />}
                >
                  <input
                    accept=".csv"
                    type="file"
                    multiple
                    hidden
                    ref={importerDocument}
                    onChange={handleChangeImporter}
                  />
                  {isImporter ? "Cambiar archivo" : "Seleccionar archivo"}
                </ButtonFile>
                {isImporter && (
                  <Chip
                    icon={<CheckCircleIcon />}
                    label="Archivo listo para procesar"
                    color="success"
                    variant="outlined"
                    sx={{ marginTop: "8px" }}
                  />
                )}
              </Box>
            </UploadArea>

            {/* Actions Section */}
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "161e55#",
                  textAlign: "center",
                  marginBottom: "24px",
                }}
              >
                Acciones Disponibles
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                {/* Primera fila - Pagar y Eliminar Cuotas */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <ModernButton
                    onClick={handleImport}
                    startIcon={<PaymentIcon />}
                    disabled={!isImporter}
                  >
                    Pagar Cuotas
                  </ModernButton>
                  <ModernButton
                    onClick={handleDeleteQuotas}
                    startIcon={<DeleteIcon />}
                    disabled={!isImporter}
                  >
                    Eliminar Cuotas
                  </ModernButton>
                </Box>

                <Divider sx={{ margin: "8px 0" }} />

                {/* Segunda fila - Registrar Cobranza y Fecha Compromiso */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <ModernButton
                    onClick={handleGestionCobranza}
                    startIcon={<AssignmentIcon />}
                    disabled={!isImporter}
                  >
                    Registrar Cobranza
                  </ModernButton>
                  <ModernButton
                    onClick={handleFechaCompromiso}
                    startIcon={<ScheduleIcon />}
                    disabled={!isImporter}
                  >
                    Fecha Compromiso
                  </ModernButton>
                </Box>

                <Divider sx={{ margin: "8px 0" }} />

                {/* Tercera fila - Aplicación de Pagos */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <ModernButton
                    onClick={handleGenerarAplicadorPagos}
                    startIcon={
                      loadingStates.generarAplicador ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <AppRegistrationIcon />
                      )
                    }
                    disabled={!isImporter || loadingStates.generarAplicador}
                  >
                    {loadingStates.generarAplicador
                      ? "Generando..."
                      : "Generar Aplicador de Pagos"}
                  </ModernButton>
                  <ModernButton
                    onClick={handleAjusteAplicacionPagos}
                    startIcon={
                      loadingStates.ajusteAplicacion ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <TuneIcon />
                      )
                    }
                    disabled={!isImporter || loadingStates.ajusteAplicacion}
                  >
                    {loadingStates.ajusteAplicacion
                      ? "Procesando..."
                      : "Ajuste de Aplicación de Pagos"}
                  </ModernButton>
                  <ModernButton
                    onClick={handleEliminarRecaudo}
                    startIcon={
                      loadingStates.eliminarRecaudo ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <RemoveCircleIcon />
                      )
                    }
                    disabled={!isImporter || loadingStates.eliminarRecaudo}
                  >
                    {loadingStates.eliminarRecaudo
                      ? "Eliminando..."
                      : "Eliminar Recaudo"}
                  </ModernButton>
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
      )}
    </React.Fragment>
  );
}
